import { MainContext } from "@context";
import types from "prop-types";
import React, { useContext, useState } from "react";
import ReactPlayer from "react-player";
import { Link } from "react-router-dom";
import styled from "styled-components";
export const HIGH_WRAPPER = styled.div`
	video {
		display: block;
	}
`;
HIGH_WRAPPER.displayName = "HIGH_WRAPPER";

export default function BannerItem({ banner, index = 1, single, onClick, bannerName }) {
	const [isExistHighVersion] = useState(banner.high && banner.high.mobile);
	const [highVersionLoaded, setHighVersionLoaded] = useState(false);
	const [lowVersionLoadaded, setLowVersionLoadaded] = useState(false);
	const { isMobile } = useContext(MainContext).state;

	const onLoadLowQuality = () => {
		setTimeout(() => {
			setLowVersionLoadaded(true);
		}, 3000);
	};
	const onLoadHighQuality = () => {
		setHighVersionLoaded(true);
	};

	const click = () => {
		window?.dataLayer?.push({
			event: "banner-item-click",
			link: banner.link,
			bannerName,
			type: banner.type,
			language: banner.language,
			order: banner.order,
		});
		onClick?.();
	};

	return (
		<Link
			to={banner.link || "/"}
			style={{ display: "block" }}
			onClick={click}
			className="link-wrapper">
			{!highVersionLoaded &&
				(single ? (
					<img
						onLoad={onLoadLowQuality}
						data-src={banner.mobile}
						className={`lazyload ${lowVersionLoadaded ? "loaded" : ""}`}
						src={index === 0 ? banner.mobile : "/placeholder.png"}
					/>
				) : (
					<picture>
						<source
							media="(min-width: 768px)"
							data-srcset={banner.tablet}
						/>
						<source
							media="(max-width: 767px)"
							data-srcset={banner.mobile}
						/>
						<img
							onLoad={onLoadLowQuality}
							data-src={isMobile ? banner.mobile : banner.tablet}
							className={`lazyload ${lowVersionLoadaded ? "loaded" : ""}`}
							src={
								index === 0
									? isMobile
										? banner.mobile
										: banner.tablet
									: "/placeholder.png"
							}
						/>
					</picture>
				))}
			{lowVersionLoadaded && isExistHighVersion && (
				<HIGH_WRAPPER
					style={{
						visibility: highVersionLoaded ? "visible" : "hidden",
						height: highVersionLoaded ? "auto" : 0,
					}}>
					{banner?.type === "video" ? (
						<ReactPlayer
							width="100%"
							height="auto"
							onStart={onLoadHighQuality}
							playing={true}
							playsinline={true}
							muted={true}
							loop={true}
							url={
								single
									? banner.high?.mobile
									: isMobile
										? banner.high?.mobile
										: banner.high?.tablet
							}></ReactPlayer>
					) : single ? (
						<img
							onLoad={onLoadLowQuality}
							data-src={banner.mobile}
							className={`lazyload ${lowVersionLoadaded ? "loaded" : ""}`}
							src={banner.high?.mobile}
						/>
					) : (
						<picture>
							<source
								media="(min-width: 768px)"
								data-srcset={banner.high?.tablet}
							/>
							<img
								onLoad={onLoadHighQuality}
								data-src={isMobile ? banner.high?.mobile : banner.high?.tablet}
								className={`lazyload ${lowVersionLoadaded ? "loaded" : ""}`}
								src={isMobile ? banner.high?.mobile : banner.high?.tablet}
							/>
						</picture>
					)}
				</HIGH_WRAPPER>
			)}
		</Link>
	);
}

//prop types
BannerItem.propTypes = {
	single: types.bool,
	banner: {
		"high": {
			"mobile": types.string,
			"tablet": types.string,
			"desktop": types.string,
			"wide": types.string,
		},
		"wide": types.string,
		"link": types.string,
		"desktop": types.string,
		"tablet": types.string,
		"mobile": types.string,
		"type": types.oneOf(["image", "video"]),
		"status": types.oneOf(["active", "disabled"]),
	},
};
